<template>
  <div class="header">
    <!-- Demi capsule de contact -->
    <a
        class="contact-tab"
        :href="getContentMail()"
        title="Contacter le support"
    >
      Un problème, une idée, n'hésitez pas à nous contacter en cliquant ici
    </a>


    <!-- Triangle Version Bêta -->
    <div class="beta-badge">
      <span>Version Bêta</span>
    </div>

    <!-- Zone gauche -->
    <em
        v-if="authVars"
        class="header-user opacity-70"
        :class="{ 'cursor-pointer': hasMultipleOfs, 'switch-available': hasMultipleOfs }"
        @click="hasMultipleOfs && emit('go-home')"
        :title="hasMultipleOfs ? 'Cliquez pour changer de centre' : ''"
    >
      <span style="font-style: normal; font-variant: small-caps;">
        {{ authVars.firstname }} {{ authVars.lastname }}
      </span>
      - {{ authVars.ofName }}
      <span v-if="hasMultipleOfs" class="switch-icon">⇄</span>
      <span class="opacity-70" style="font-size: 12px;">
        <br/>{{ authVars.campusAddress }}
      </span>
      <span class="opacity-70" style="font-size: 12px;">
        <br/>{{ authVars.campusPostalCode }} {{ authVars.campusCityName }}
      </span>
    </em>

    <!-- Zone centrale -->
    <div class="header-main">
      <h2>
        <span v-if="loading">Chargement...</span>
        <span v-else>{{ title }}</span>
      </h2>
      <div class="header-meta" v-if="$slots.meta">
        <slot name="meta"></slot>
      </div>
    </div>

    <!-- Zone actions -->
    <div class="header-actions">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from 'vue'
import {usePlanningStore} from '@/store/planningStore'

const planningStore = usePlanningStore()

const props = defineProps({
  title: {type: String, required: true},
  loading: {type: Boolean, default: false},
  authVars: {type: Object, required: true},
})
const emit = defineEmits(['go-home'])

const hasMultipleOfs = ref(false)


watch(() => props.authVars, (newAuthVars) => {
  if (newAuthVars && newAuthVars.ofObjId && newAuthVars.userAccountObjId) {
    planningStore.fetchOfList(newAuthVars.ofObjId, newAuthVars.userAccountObjId)
        .then((data) => {
          hasMultipleOfs.value = data && data.length > 1;

          // Préchargement des données pour chaque OF (une seule fois)
          if (!planningStore.preloadDone && data && data.length > 0) {
            planningStore.preloadDone = true
            setTimeout(() => {
              planningStore.searchInterviewManagers(newAuthVars.ofObjId, newAuthVars.userAccountObjId, 'ABC').catch(() => {
              })
              setTimeout(() => {
                planningStore.searchCandidacies(newAuthVars.ofObjId, newAuthVars.userAccountObjId, 'ABC').catch(() => {
                })
              }, 3000)
            }, 3000)

            // Fonction de préchargement en arrière-plan (silencieux pour ne pas afficher d'erreurs)
            const preloadData = () => {
              data.slice(0, 2).forEach((of, index) => {
                // Espacer les appels de 1.5s pour éviter de saturer le navigateur
                setTimeout(() => {
                  planningStore.searchInterviewManagers(of.ofObjId, newAuthVars.userAccountObjId, 'ABC').catch(() => {
                  })
                  // Décaler le second appel de 300ms
                  setTimeout(() => {
                    planningStore.searchCandidacies(of.ofObjId, newAuthVars.userAccountObjId, 'ABC').catch(() => {
                    })
                  }, 2000)
                }, 2000 * index)
              })
            }

            // Utiliser requestIdleCallback pour ne pas bloquer l'UI
            if ('requestIdleCallback' in window) {
              requestIdleCallback(preloadData, {timeout: 4000})
            } else {
              setTimeout(preloadData, 2000)
            }
          }
        })
        .catch(() => {
          hasMultipleOfs.value = false
        })
  }
}, {immediate: false})


function getContentMail() {
  let texte = '-------------------------------------------'
  texte += '%0D%0AUrl: ' + encodeURIComponent(document.location.href.split('?')[0])
  texte += '%0D%0A-------------------------------------------'
  texte += '%0D%0ANom: '
  texte += '%0D%0AEmail: '
  texte += '%0D%0A-------------------------------------------'
  texte += '%0D%0AMessage:%0D%0A '
  texte += '%0D%0A-------------------------------------------'
  return 'mailto:si@apform.fr?subject=Outil planification entretiens&body=' + texte
}

</script>

<style scoped>


/* Demi capsule onglet contact */
.contact-tab {
  position: absolute;
  top: -20px;
  left: 0;
  transform: translateY(-50%);
  background: #0078d7;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 0.4rem 1rem;
  border-radius: 0 0 12px 12px; /* arrondis en bas (ouvert vers le haut) */
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: all 0.25s ease;
  z-index: 10;
}

.contact-tab:hover {
  background: #005ea3;
  transform: translateY(-45%);
}


.header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  padding: 0.5rem 0.5em;
}

/* Triangle jaune en haut à gauche avec texte dedans */
.beta-badge {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 80px solid #FFD700; /* triangle jaune plus grand */
  border-right: 80px solid transparent;
  z-index: 2;
  overflow: visible;
}

.beta-badge span {
  position: absolute;
  top: -36px; /* position verticale ajustée pour centrer le texte sur le triangle */
  left: -11px;
  width: 80px;
  text-align: center;
  transform: rotate(-45deg);
  transform-origin: top left;
  color: #000;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  pointer-events: none; /* pas cliquable */
}

/* Décalage plus marqué de la zone gauche */
.header-user {
  position: relative;
  margin-left: 4rem; /* décalage augmenté */
  max-width: 250px;
}

/* Style pour indiquer qu'un switch de centre est possible */
.switch-available:hover {
  color: #0078d7;
}

.switch-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  font-style: normal;
  font-size: 12px;
  color: #000;
  background-color: #FFD700;
  padding: 2px 4px;
  border-radius: 3px;
  line-height: 1;
}

/* Bloc central : centré horizontalement et verticalement */
.header-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  text-align: center;
  gap: 0.3rem;
  min-width: 0;
}

/* Titre principal */
.header h2 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Ligne informative sous le titre */
.header-meta {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.65);
}

/* Zone des actions (boutons à droite) */
.header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
</style>
